import { IDataWithLocalizedName } from '../../contracts/localized-data.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class OverrideNameComponent extends Component implements IDataWithLocalizedName {
  static readonly TYPE_ID: string = '10b7665b6e624c85926b399255534cf4';

  constructor(
    public readonly names: LocalizedString,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return OverrideNameComponent.TYPE_ID;
  }

  static empty(): OverrideNameComponent {
    return new OverrideNameComponent(LocalizedString.empty());
  }

  static fromMap(context: SerializationContext, map: SerializedData): OverrideNameComponent {
    return new OverrideNameComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'names')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'names': context.toData(this.names),
    };
  }

  clone(): this {
    return new OverrideNameComponent(
        this.names.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.names, this.names);
  }
}

export class OverrideNameComponentBuilder extends DataModelBuilder<OverrideNameComponent> {
  build(context: SerializationContext, map: SerializedData): OverrideNameComponent {
    return OverrideNameComponent.fromMap(context, map);
  }
}
